import { useOnboardingContext } from '../context/OnboardingContext';
import OnboardingOutreach from '../scenes/OnboardingOutreach';
import OnboardingOffering from '../scenes/OnboardingOffering';
import OnboardingValue from '../scenes/OnboardingValue';
import OnboardingSignature from '../scenes/OnboardingSignature';
import OnboardingGenerating from '../scenes/OnboardingGenerating';
import { OnboardingWelcome } from '../scenes/OnboardingWelcome';

export default function OnboardingPageSelector() {
	const { currentPage } = useOnboardingContext();

	return (
		<div className="flex h-full w-full flex-col overflow-auto rounded-tl-lg rounded-tr-lg bg-onboarding bg-cover bg-top lg:rounded-tr-none lg:bg-center">
			{currentPage === 'WELCOME' && <OnboardingWelcome />}
			{currentPage === 'OUTREACH' && <OnboardingOutreach />}
			{currentPage === 'OFFERING' && <OnboardingOffering />}
			{currentPage === 'VALUE' && <OnboardingValue />}
			{currentPage === 'SIGNATURE' && <OnboardingSignature />}
			{currentPage === 'GENERATING' && <OnboardingGenerating />}
		</div>
	);
}
